import moment from "moment"

export const formatAPIData = (data) => {
    const newData = {
        id:data.id,
        orderIds:data.order_ids,
        title:data.title,
        description:data.description,
        referenceId:data.reference_id,
        reporterContactName:data.reporter_contact_name,
        reporterContactPhone:data.reporter_contact_phone,
        type:data.type,
        status:data.status,
        comments:data.comments,
        createdBy:data.created_by,
        createdAt:moment(data.created_at).format("DD MMM YYYY"),
        processedAt:moment(data.processed_at).format("DD MMM YYYY"),
        solvedAt:moment(data.solved_at).format("DD MMM YYYY"),
    }
    return newData
}

export const typeFormat = (type) => {
    let newType;
    switch (type) {
        case `complaint_shipment`:
            newType = `Komplain Pengiriman`;
            break;
        case `complaint_woocommerce`:
            newType = `WooCommerce`;
            break;
        case `complaint_dashboard`:
            newType = `Komplain Dashboard`;
            break;
        case `complaint_cod`:
            newType = `Kendala COD`;
            break;
        case `claim`:
            newType = `Klaim Pengiriman`;
            break;
        case `shipping_status`:
            newType = `Status Pengiriman`;
            break;
        case `payment`:
            newType = `Pembayaran`;
            break;
        case `product_feature`:
            newType = `Fitur Produk`;
            break;
        case `service_error`:
            newType = `Error Layanan`;
            break;
        default:
            break;
    }
    return newType
}